import React, { useEffect, useState } from 'react';
import Data from '../../Data/Data.json'
import { Button, Form, Space, Table, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import PageNotFound from '../../Pages/PageNotFound';
import formatNumber from '../../Functions/Traitement/FormatNumber';
import { Backpack, Backspace, BackspaceSharp, Print } from '@mui/icons-material';
import { Backdrop, Box } from '@mui/material';
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/greenLogo.png"
import i18next from 'i18next';
import { ColumnsType } from 'antd/es/table';
import NumberToLetter from '../../Functions/Traitement/NumberToLetter';
import ReformatNumber from '../../Functions/Traitement/ReformatNumber';

const PrintEtatCaisse = () => {
    const [data, setDate] = React.useState(localStorage.getItem(Data.LocalVariable.etatCaisse) ? JSON.parse(localStorage.getItem(Data.LocalVariable.etatCaisse) + "") : null as any)
    const [caisse, setCaisse] = useState<any>()
    const [biellets, setBiellets] = useState<any[]>([])
    const [pieces, setPieces] = useState<any[]>([])
    const [montTotal, setMontTotal] = useState("")
    const navigate = useNavigate();
    // USER SESSION
    const auth = useAuthUser();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    useEffect(() => {
        try {
            //alert(JSON.stringify(data.form))
            setCaisse(JSON.parse(localStorage.getItem(Data.LocalVariable.etatCaisse) as any))
            var b = []
            var p = []
            b.push({
                "biellet": "10 000",
                "nombre": formatNumber((parseInt(data.form.NOMB01)? parseInt(data.form.NOMB01) : 0)),
                "total": formatNumber(10000 * (parseInt(data.form.NOMB01)? parseInt(data.form.NOMB01) : 0))
            },
                {
                    "biellet": "5 000",
                    "nombre": formatNumber((parseInt(data.form.NOMB02)? parseInt(data.form.NOMB02) : 0)),
                    "total": formatNumber(5000 * (parseInt(data.form.NOMB02)? parseInt(data.form.NOMB02) : 0))
                },
                {
                    "biellet": "2 000",
                    "nombre": formatNumber((parseInt(data.form.NOMB03)? parseInt(data.form.NOMB03) : 0)),
                    "total": formatNumber(2000 * (parseInt(data.form.NOMB03)? parseInt(data.form.NOMB03) : 0))
                },
                {
                    "biellet": "1 000",
                    "nombre": formatNumber((parseInt(data.form.NOMB04)? parseInt(data.form.NOMB04) : 0)),
                    "total": formatNumber(1000 * (parseInt(data.form.NOMB04)? parseInt(data.form.NOMB04) : 0))
                },
                {
                    "biellet": "500",
                    "nombre": formatNumber((parseInt(data.form.NOMB05)? parseInt(data.form.NOMB05) : 0)),
                    "total": formatNumber(500 * (parseInt(data.form.NOMB05)? parseInt(data.form.NOMB05) : 0))
                },
                {
                    "biellet": "TOTAL",
                    "nombre": parseInt(data.form.NOMB01)? parseInt(data.form.NOMB01) : 0 + parseInt(data.form.NOMB02)? parseInt(data.form.NOMB02) : 0 + parseInt(data.form.NOMB03)? parseInt(data.form.NOMB03) : 0 + parseInt(data.form.NOMB04)? parseInt(data.form.NOMB04) : 0 + parseInt(data.form.NOMB05)? parseInt(data.form.NOMB05) : 0,
                    "total": formatNumber((10000 * (parseInt(data.form.NOMB01)? parseInt(data.form.NOMB01) : 0)) + (5000 * (parseInt(data.form.NOMB02)? parseInt(data.form.NOMB02) : 0)) + (2000 * (parseInt(data.form.NOMB03)? parseInt(data.form.NOMB03) : 0)) + (1000 * (parseInt(data.form.NOMB04)? parseInt(data.form.NOMB04) : 0)) + (500 * (parseInt(data.form.NOMB05)? parseInt(data.form.NOMB05) : 0)))
                }
            )
            setBiellets(b)

            p.push({
                "piece": "500",
                "nombre": formatNumber((parseInt(data.form.NOMB06)? parseInt(data.form.NOMB06) : 0)),
                "total": formatNumber(500 * (parseInt(data.form.NOMB06)? parseInt(data.form.NOMB06) : 0))
            },
                {
                    "piece": "100",
                    "nombre": formatNumber((parseInt(data.form.NOMB07)? parseInt(data.form.NOMB07) : 0)),
                    "total": formatNumber(100 * (parseInt(data.form.NOMB07)? parseInt(data.form.NOMB07) : 0))
                },
                {
                    "piece": "50",
                    "nombre": formatNumber((parseInt(data.form.NOMB08)? parseInt(data.form.NOMB08) : 0)),
                    "total": formatNumber(50 * (parseInt(data.form.NOMB08)? parseInt(data.form.NOMB08) : 0))
                },
                {
                    "piece": "25",
                    "nombre": formatNumber((parseInt(data.form.NOMB09)? parseInt(data.form.NOMB09) : 0)),
                    "total": formatNumber(25 * (parseInt(data.form.NOMB09)? parseInt(data.form.NOMB09) : 0))
                },
                {
                    "piece": "10",
                    "nombre": formatNumber((parseInt(data.form.NOMB10)? parseInt(data.form.NOMB10) : 0)),
                    "total": formatNumber(10 * (parseInt(data.form.NOMB10)? parseInt(data.form.NOMB10) : 0))
                },
                {
                    "piece": "5",
                    "nombre": formatNumber((parseInt(data.form.NOMB11)? parseInt(data.form.NOMB11) : 0)),
                    "total": formatNumber(5 * (parseInt(data.form.NOMB11)? parseInt(data.form.NOMB11) : 0))
                },
                {
                    "piece": "2",
                    "nombre": formatNumber((parseInt(data.form.NOMB12)? parseInt(data.form.NOMB12) : 0)),
                    "total": formatNumber(2 * (parseInt(data.form.NOMB12)? parseInt(data.form.NOMB12) : 0))
                },
                {
                    "piece": "1",
                    "nombre": formatNumber((parseInt(data.form.NOMB13)? parseInt(data.form.NOMB13) : 0)),
                    "total": formatNumber(1 * (parseInt(data.form.NOMB13)? parseInt(data.form.NOMB13) : 0))
                },
                {
                    "piece": "TOTAL",
                    "nombre": parseInt(data.form.NOMB06)? parseInt(data.form.NOMB06) : 0 + parseInt(data.form.NOMB07)? parseInt(data.form.NOMB07) : 0 + parseInt(data.form.NOMB08)? parseInt(data.form.NOMB08) : 0 + parseInt(data.form.NOMB09)? parseInt(data.form.NOMB09) : 0 + parseInt(data.form.NOMB10)? parseInt(data.form.NOMB10) : 0 + parseInt(data.form.NOMB11)? parseInt(data.form.NOMB11) : 0 + parseInt(data.form.NOMB12)? parseInt(data.form.NOMB12) : 0 + parseInt(data.form.NOMB13)? parseInt(data.form.NOMB13) : 0,
                    "total": formatNumber((500 * (parseInt(data.form.NOMB06)? parseInt(data.form.NOMB06) : 0)) + (100 * (parseInt(data.form.NOMB07)? parseInt(data.form.NOMB07) : 0)) + (50 * (parseInt(data.form.NOMB08)? parseInt(data.form.NOMB08) : 0)) + (25 * (parseInt(data.form.NOMB09)? parseInt(data.form.NOMB09) : 0)) + (10 * (parseInt(data.form.NOMB10)? parseInt(data.form.NOMB10) : 0)) + (5 * (parseInt(data.form.NOMB11)? parseInt(data.form.NOMB11) : 0)) + (2 * (parseInt(data.form.NOMB12)? parseInt(data.form.NOMB12) : 0)) + (1 * (parseInt(data.form.NOMB13)? parseInt(data.form.NOMB13) : 0)))
                }
            )
            setPieces(p)
            setMontTotal(formatNumber((10000 * (parseInt(data.form.NOMB01)? parseInt(data.form.NOMB01) : 0)) + (5000 * (parseInt(data.form.NOMB02)? parseInt(data.form.NOMB02) : 0)) + (2000 * (parseInt(data.form.NOMB03)? parseInt(data.form.NOMB03) : 0)) + (1000 * (parseInt(data.form.NOMB04)? parseInt(data.form.NOMB04) : 0)) + (500 * (parseInt(data.form.NOMB05)? parseInt(data.form.NOMB05) : 0)) + (500 * (parseInt(data.form.NOMB06)? parseInt(data.form.NOMB06) : 0)) + (100 * (parseInt(data.form.NOMB07)? parseInt(data.form.NOMB07) : 0)) + (50 * (parseInt(data.form.NOMB08)? parseInt(data.form.NOMB08) : 0)) + (25 * (parseInt(data.form.NOMB09)? parseInt(data.form.NOMB09) : 0)) + (10 * (parseInt(data.form.NOMB10)? parseInt(data.form.NOMB10) : 0)) + (5 * (parseInt(data.form.NOMB11)? parseInt(data.form.NOMB11) : 0)) + (2 * (parseInt(data.form.NOMB12)? parseInt(data.form.NOMB12) : 0)) + (1 * (parseInt(data.form.NOMB13)? parseInt(data.form.NOMB13) : 0))))
        } catch (error) {

        }
        if (data == null) {
            navigate(-1)
        }
    })

    const columns1: ColumnsType<any> = [
        {
            title: 'Valeur Billets',
            dataIndex: 'biellet',
            width: "140px"
        },
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            width: "140px"
        },
        {
            title: 'Produit',
            dataIndex: 'total',
            width: "140px"
        }
    ];

    const columns2: ColumnsType<any> = [
        {
            title: 'Valeur Pièce',
            dataIndex: 'piece',
            width: "140px"
        },
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            width: "140px"
        },
        {
            title: 'Produit',
            dataIndex: 'total',
            width: "140px"
        }
    ];
    return (
        <div className='bordureRecu'><br />
            {data ?
                <>
                    <Box className='backBtnt' onClick={() => { navigate(-1) }}><Backspace /></Box>
                    <Box width={900} className={"preview_print"}>
                        <Box style={{ border: "1px rgba(0, 0, 0, .2) solid", padding: "5px", borderRadius: '5px' }} className={"title"} display={"flex"} fontStyle={"inherit"}>

                            <Box>
                                <Typography>{"{BANK_NAME}"}</Typography>
                                <Typography>{user.codage + " (" + user.agence+ ")"}</Typography>
                            </Box><hr />
                            <Box marginLeft={20}>
                                <Typography style={{ fontSize: "100%", textAlign : 'center' }}>
                                    <b><u>{data.form.titre}</u></b>
                                </Typography>

                                <Typography>
                                    <Typography style={{ textAlign: "center", background: "rgba(0, 0, 0, .1)", borderRadius: "3px", border: ".5px rgba(0, 0, 0, .3) solid" }}><b >{data.form.NUMRAP}</b></Typography>
                                </Typography>
                            </Box>

                            <hr className='hide' />
                            <Box >
                                <Typography>{"Date : " + user.datjour + " / Heure : " + (new Date(Date.now())).toLocaleTimeString(i18next.language)}</Typography>
                                <Typography>{"Caissier(e) : " + user.coduti+' - '+user.nomuti}</Typography>
                            </Box>
                            <Button title='Imprimer ( ctrl + p )' onClick={() => { window.print() }} icon={<Print />} size='large' className='bt_add' type="ghost" htmlType="button" block  ></Button>
                        </Box><br />
                        <Box fontStyle={"inherit"} display={"flex"}>
                            <Box>
                                <Typography className='hidden' style={{color: "white", backgroundColor: "white"}}>-----------------------------------------------</Typography><br />

                                
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>N° Caisse : </Typography><hr /><b style={{marginLeft: "10px"}}>{data?.form?.NODECE}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Nom Caisse : </Typography><hr /><b style={{marginLeft: "10px"}}>{data?.form?.LECEON}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Compte Caisse : </Typography><hr /><b style={{marginLeft: "10px"}}>{data?.form?.NUMCPT}</b></Box><br />

                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Encaisse début de Journée : </Typography><hr /><b style={{marginLeft: "10px"}}>{formatNumber(data?.form?.EEDTJE)}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Versement : </Typography><hr /><b style={{marginLeft: "10px"}}>{formatNumber(data?.form?.CLOSVT)}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Paiements : </Typography> <hr /><b style={{marginLeft: "10px"}}>{formatNumber(data?.form?.CLOSPT)}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Reception coffre : </Typography> <hr /><b style={{marginLeft: "10px"}}>{formatNumber(data?.form?.MTRECOFF)}</b></Box>
                            </Box><hr />
                            <Box marginLeft={20}>
                                <Typography>{"Imprimé par " + user.coduti + " - " + user.nomuti + " le " + (new Date(Date.now())).toLocaleDateString(i18next.language) + " à " + (new Date(Date.now())).toLocaleTimeString(i18next.language)}</Typography><br />

                                
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Entrée fond banque : </Typography><hr /><b style={{marginLeft: "10px"}}>{formatNumber(data?.form?.MTENFDBANQ)}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Sortie fond banque : </Typography> <hr /><b style={{marginLeft: "10px"}}>{formatNumber(data?.form?.MTSTFDBANQ)}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Emission coffre : </Typography> <hr /><b style={{marginLeft: "10px"}}>{formatNumber(data?.form?.MTEMCOFF)}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Recept° autre caisse : </Typography> <hr /> <b style={{marginLeft: "10px"}}>{(formatNumber(data?.form?.MTDIVRE))}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Emission autre caisse : </Typography> <hr /> <b style={{marginLeft: "10px"}}>{(formatNumber(data?.form?.MTDIVEM))}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Encaissement physique : </Typography> <hr /> <b style={{marginLeft: "10px"}}>{(formatNumber(data?.form?.EETSRL))}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Encaissement informatique : </Typography> <hr /> <b style={{marginLeft: "10px"}}>{(formatNumber(data?.form?.EEPEAE))}</b></Box>
                                <Box fontStyle={"inherit"} display={"flex"}><Typography>Ecart de caisse : </Typography> <hr /> <b style={{marginLeft: "10px"}}>{(formatNumber(data?.form?.difference))}</b></Box>
                            </Box>
                        </Box>
                        <br />

                        <Box fontSize={"smaller"} display={'flex'} fontStyle={'inherit'}>
                            <Box>

                                <Table bordered size='small' pagination={false} columns={columns1} dataSource={biellets} /><br />

                            </Box>
                            <hr />
                            <Table bordered size='small' pagination={false} columns={columns2} dataSource={pieces} />
                        </Box><br />
                        <Box fontStyle={"inherit"} display={"flex"}>
                            <Box>
                                <Typography style={{ textAlign: "center" }}>Signature Caissier(ère)</Typography>
                                <Box style={{ border: "1px rgba(0, 0, 0, .1) solid", backgroundColor: 'rgba(0, 0, 0, .05', width: '350px', height: "80px", borderRadius: "5px" }}></Box>
                            </Box>
                            <hr />
                            <Box marginLeft={20}>
                                <Typography style={{ textAlign: "center" }}>Signature Controlleur</Typography>
                                <Box style={{ border: "1px rgba(0, 0, 0, .1) solid", backgroundColor: 'rgba(0, 0, 0, .05', width: '350px', height: "80px", borderRadius: "5px" }}></Box>
                            </Box>
                        </Box>
                    </Box>

                </>
                :
                <PageNotFound message={"Nothing to print"} backLink={"/prets/simulation"} texttButton={"Back to Loan Simulator"} />}
        </div >
    );
};

export default PrintEtatCaisse;